import { http, http_main } from '@/environment/environment';

class TokenService
{
    createToken(data: any, jwtToken: string, network: string): Promise<any> {
        if(network == 'testnet'){
            http.defaults.headers.common['Authorization'] = jwtToken;
            return http.post('tokens', data);
        }else{
            http_main.defaults.headers.common['Authorization'] = jwtToken;
            return http_main.post('tokens', data);
        }
    }

    updateTokenDetails(tokenId: string, userId: string, jwtToken: string, network: string, data: any): Promise<any> {
        if(network=='testnet'){
            http.defaults.headers.common['Authorization'] = jwtToken;
            return http.put(`tokens/${tokenId}?userId=${userId}`, data);
        }else{
            http_main.defaults.headers.common['Authorization'] = jwtToken;
            return http_main.put(`tokens/${tokenId}?userId=${userId}`, data);
        }
    }

    getToken(tokenId: string, userId: string, network: string): Promise<any> {
        if(network == 'testnet'){
            return http.get(`tokens/${tokenId}?userId=${userId}`);
        }else{
            return http_main.get(`tokens/${tokenId}?userId=${userId}`);
        }
    }

    getTokenListByWalletAddress(walletAddress: string, network: string): Promise<any> {
        if(network == 'testnet'){
            return http.get(`wallets/${walletAddress}/tokens?ignoreExternal=true&limit=100`);
        }else{
            return http_main.get(`wallets/${walletAddress}/tokens?ignoreExternal=true&limit=100`);
        }
    }

    getAssetList(walletAddress: string, network: string): Promise<any> {
        if(network=='testnet'){
            return http.get(`wallets/${walletAddress}/assets?ignoreLinked=true&ignoreExternal=true`);
        }else{
            return http_main.get(`wallets/${walletAddress}/assets?ignoreLinked=true&ignoreExternal=true`);
        }
    }

    getGamesAttachedToToken(tokenId: string, network: string): Promise<any> {
        if(network=='testnet'){
            return http.get(`tokens/${tokenId}/attach`);
        }else{
            return http_main.get(`tokens/${tokenId}/attach`);
        }
    }

    attachTokensToGame(tokenId: string, gameId: string, userId: string, jwtToken: string, network: string): Promise<any> {
        if(network=='testnet'){
            http.defaults.headers.common['Authorization'] = jwtToken;
            return http.post(`tokens/${tokenId}/attach?userId=${userId}&gameId=${gameId}`);
        }else{
            http_main.defaults.headers.common['Authorization'] = jwtToken;
            return http_main.post(`tokens/${tokenId}/attach?userId=${userId}&gameId=${gameId}`);
        }
    }
}

export default new TokenService();